import { render, staticRenderFns } from "./ListaDossier.vue?vue&type=template&id=2b216ca4"
import script from "./ListaDossier.vue?vue&type=script&lang=js"
export * from "./ListaDossier.vue?vue&type=script&lang=js"
import style0 from "./ListaDossier.vue?vue&type=style&index=0&id=2b216ca4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports